import { __rest } from "tslib";
import React from 'react';
import { flex } from '~/theme/flex.css';
import { cn } from '~/utils';
const FLEX_NAME = 'vulcanui-flex';
const Flex = React.forwardRef((props, ref) => {
    const { align, as: Comp = 'div', basis, children, className, direction, display = 'flex', gap, grow, justify, shrink, wrap } = props, restProps = __rest(props, ["align", "as", "basis", "children", "className", "direction", "display", "gap", "grow", "justify", "shrink", "wrap"]);
    return (React.createElement(Comp, Object.assign({ className: cn(FLEX_NAME, className, flex({ align, basis, direction, display, gap, grow, justify, shrink, wrap })), ref: ref }, restProps), children));
});
Flex.displayName = 'Flex';
Flex.toString = () => `.${FLEX_NAME}`;
export default Flex;
//# sourceMappingURL=flex.js.map